export class WtrCategoryModel {
    public id: string;
    public companyMenuCategoryId: string;
    public name: string;
    public description: string;
    public createDate: any;
    public modifiedDate: any;
    public languageId: number;
    public parent: any;
    public pictureURL: string;
    public venueId: string;
    public venueMenuCategoryId: string;
    public venueMenuId: string;
    public venueMenuItems: Array<any>;
    public childVenueMenuCategories: Array<WtrCategoryModel>;
    public active: boolean;
    public visible: boolean;
}